import React, { useState, useEffect } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import videojs from '!video.js';
import MuvikaService from './../../services/muvika';
import IntervalService from './../../services/intervals';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import IosVolumeControl from './../../services/volume';
import 'video.js/dist/video-js.css';
import { getOS, getPlatform, isIPhone, isPossiblyIPad } from '../../services/os';
import { throttle } from '../../services/throttle';
import { Capacitor } from '@capacitor/core';
import sessionStore from '../../stores/session';
import settingsStore from '../../stores/settings';
import playerStore from '../../stores/player';
import singersStore from './../../stores/singers';
import musicPlayerStore from '../../stores/musicPlayer';
import bgPerformanceStore from '../../stores/bgPerformance';
import navigationStore from '../../stores/navigation';
import bgFiltersStore from '../../stores/bgFilters';

export const BackgroundMusicPlayer = (props) => {



  const itemsOnPage = 25;

  const sessionToken = sessionStore((state) => state.sessionToken);
  const currentVolume = musicPlayerStore((state) => state.currentVolume);
  const streamUrl = musicPlayerStore((state) => state.streamUrl);
  const currentTime = musicPlayerStore((state) => state.currentTime);
  const setCurrentTime = musicPlayerStore((state) => state.setCurrentTime);
  const setIsPlaying = musicPlayerStore((state) => state.setIsPlaying);
  const isPlaying = musicPlayerStore((state) => state.isPlaying);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const setCurrentBuffer = musicPlayerStore((state) => state.setCurrentBuffer);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setIsFading = musicPlayerStore((state) => state.setIsFading);
  const from = musicPlayerStore((state) => state.from);
  const currentPerformanceId = musicPlayerStore((state) => state.currentPerformanceId);
  const setVolume = musicPlayerStore((state) => state.setVolume);
  const fadeVolume = musicPlayerStore((state) => state.fadeVolume);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const isPaused = musicPlayerStore((state) => state.isPaused);
  const currentPerformance = bgPerformanceStore((state) => state.currentPerformance);
  const getStreamUrl = musicPlayerStore((state) => state.getStreamUrl);
  const singers = singersStore((state) => state.singers);
  const currentTrack = musicPlayerStore((state) => state.currentTrack);
  const deletePerformance = bgPerformanceStore((state) => state.deletePerformance);
  const addPerformanceToHistory = bgPerformanceStore((state) => state.addPerformanceToHistory);
  const setIsWaitingForNextPrev = musicPlayerStore((state) => state.setIsWaitingForNextPrev);
  const isGettingMusic = bgPerformanceStore((state) => state.isWaiting);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const playQueue = bgPerformanceStore((state) => state.playQueue);
  const playerFilter = bgFiltersStore((state) => state.playerFilter);
  const getMoreTracks = bgPerformanceStore((state) => state.getMoreTracks);
  const repeatPlayList = bgPerformanceStore((state) => state.repeatPlayList);
  const addPlayListToTheEnd = bgPerformanceStore((state) => state.addPlayListToTheEnd);
  const emptyPlayer = musicPlayerStore((state) => state.empty);
  const setIsMusicReallyPaused = musicPlayerStore((state) => state.setIsMusicReallyPaused);
  const isMusicReallyPaused = musicPlayerStore((state) => state.isMusicReallyPaused);

  const musicRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const options = props.options;

  const setPlayerVolume = (volume, isSetVolumeFlagFalse = false) => {
    console.log("player volume", volume)
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        if (isPlayerStopped.isStopped || !isMusicReallyPaused.isPaused) {
          IosVolumeControl.setDeviceVolume(volume, isSetVolumeFlagFalse);
        } else {
          setTimeout(() => navigationStore.getState().setVolumeFlag(false), 200);
        }
      } else {
        player.volume(volume);
      }
      //setVolume(volume);
    }
  };

  const getPlayerVolume = () => {
    const player = playerRef.current;
    if (player) {
      if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
        let vol = IosVolumeControl.getDeviceVolume();
        return isNaN(vol) ? 1 : vol;
      } else {
        return player.volume();
      }
    }
  };

  const initPlayer = () => {
    const musicElement = document.createElement("video-js");

    musicElement.classList.add('vjs-16-9');
    musicRef.current.appendChild(musicElement);

    const player = playerRef.current = videojs(musicElement, options, () => {
    });

    player.on('playing', function () {
      if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
        setPlayerVolume(1);
      } else {
        setTimeout(() => {
          if (!IntervalService.isFadingIn() && !IntervalService.isFadingOut()) {
            console.log("setting volume on playing", musicPlayerStore.getState().currentVolume.currentVolume)
            setPlayerVolume(musicPlayerStore.getState().currentVolume.currentVolume)
          }
        }, 150);
      }
    });

    player.on('progress', function () {
      let buffEnd = player.bufferedEnd();
      setCurrentBuffer(buffEnd / player.duration());
    });

    setPlayerVolume(currentVolume.currentVolume);
    player.playsinline(true);
  };

  useEffect(() => {
    if (!playerRef.current) {
      initPlayer();
    }
  });

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
    setIsFading(false);
  }, []);

  const [isVolumeSetFromSettings, setVolumeSetFromSettings] = useState(false);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!isVolumeSetFromSettings) {
        if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
          if (settings) {
            if (settings.music_volume) {
              setVolumeSetFromSettings(true);
              setVolume(settings.music_volume / 100);
              console.log("player volume b", settings.music_volume / 100)
              setPlayerVolume(settings.music_volume / 100);
            }
          }
        } else {
          setPlayerVolume(1);
        }
      }
    }
  }, [settings]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      console.log(currentPerformance);
      if (currentPerformance) {
        if (currentPerformanceId) {
          if (currentPerformanceId != currentPerformance.unique_id) {
            console.log("cP 1");
            getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, currentPerformance.profile, musicPlayerStore.getState().isPaused.isPaused);
          }
        } else {
          console.log("cP 2");
          getStreamUrl(sessionToken, currentPerformance, currentPerformance.track, currentPerformance.profile, musicPlayerStore.getState().isPaused.isPaused);
        }
      } else {
        player.src();
        musicPlayerStore.getState().softReset();
      }
    }
  }, [currentPerformance]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      //console.log("isPaused " + isPaused.isPaused);
      if (isPaused.triggerFade) {
        if (isPaused.isPaused) {
          setIsPlaying(false);
        } else {
          if (isPlayerStopped.isStopped) {
            setIsPlaying(true);
          }
        }
      }
    }
  }, [isPaused]);

  const fadeIn = () => {
    const player = playerRef.current;
    if (player) {
      /*       if (playerStore.getState().isInIosExternalScreen) {
              setTimeout(() => player.play(), 200);
              setIsWaitingForNextPrev(false);
            } else { */
      if (IntervalService.isFadingOut()) {
        IntervalService.clearMusicFadeOutInterval();
      }
      if (!IntervalService.isFadingIn()) {
        console.log("fadeIn");
        navigationStore.getState().setVolumeFlag(true);
        navigationStore.getState().setUserVolumeFlag(false);
        musicPlayerStore.getState().setIsMusicReallyPaused(false);
        let times = 10;
        let volume = 0;
        let toVolume = settings.music_volume / 100;
        if ((isIPhone() || isPossiblyIPad()) && !Capacitor.isNativePlatform()) {
          toVolume = 1;
        }
        let upBy = toVolume / times;
        console.log("volume", getPlayerVolume(), toVolume)
        if (getPlayerVolume() > 0 || Math.abs(getPlayerVolume() - toVolume) > 0) {
          setPlayerVolume(0);
          player.play();
          let interval = setInterval(function () {
            if (times > 0) {
              console.log("player volume d", volume, upBy)
              volume = volume + upBy;
              console.log("player volume d", volume, upBy)
              console.log("Volume event fadeIn")
              setPlayerVolume(volume, times - 1 === 0);
              times = times - 1;
            } else {
              IntervalService.clearMusicFadeInInterval();
              musicPlayerStore.getState().setIsFading(false);
              setIsWaitingForNextPrev(false);
            }
          }, 100);
          IntervalService.addMusicFadeInInterval(interval);
        } else {
          IntervalService.clearMusicFadeInInterval();
          console.log("player volume c", settings.music_volume / 100)
          setPlayerVolume(toVolume, true);
          player.play();
          musicPlayerStore.getState().setIsFading(false);
          setIsWaitingForNextPrev(false);
        }
      }
      //}
    };
  };

  const fadeOut = () => {
    const player = playerRef.current;
    if (player) {
      /*       if (playerStore.getState().isInIosExternalScreen) {
              player.pause();
              setIsWaitingForNextPrev(false);
            } else { */
      if (IntervalService.isFadingIn()) {
        IntervalService.clearMusicFadeInInterval();
      }
      if (!IntervalService.isFadingOut()) {
        console.log("fadeOut");
        navigationStore.getState().setVolumeFlag(true);
        navigationStore.getState().setUserVolumeFlag(false);
        let times = 10;
        let volume = currentVolume.currentVolume;
        let reduceBy = volume / times;
        let interval = setInterval(function () {
          if (times > 0) {
            volume = volume - reduceBy;
            console.log("player volume f", volume)
            setPlayerVolume(volume, times - 1 === 0);
            times = times - 1;
          } else {
            IntervalService.clearMusicFadeOutInterval();
            musicPlayerStore.getState().setIsFading(false);
            player.pause();
            if (!musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
              musicPlayerStore.getState().setIsMusicReallyPaused(true);
            }
            setIsWaitingForNextPrev(false);
          }
        }, 100);
        IntervalService.addMusicFadeOutInterval(interval);
      }
      //}
    }
  };

  /* const fadeOut = () => { 
    if (!musicPlayerStore.getState().isFading) {
      musicPlayerStore.getState().setIsFading(true);
      const player = playerRef.current;
      if (player) {
        let times = 10;
        let volume = currentVolume;
        let reduceBy = volume / times;
        let interval = setInterval(function () {
          if (times > 0) {
            volume = volume - reduceBy;
            //setVolume(volume);
            //console.log(volume);
            player.volume(volume);
            times = times - 1;
          } else {
            clearInterval(interval);
            musicPlayerStore.getState().setIsFading(false);
            player.pause();
          }
        }, 100);
      }
    }
  };
   
  const fadeIn = () => { 
    if (!musicPlayerStore.getState().isFading) {
      musicPlayerStore.getState().setIsFading(true);
      const player = playerRef.current;
      if (player) {
        player.play();
        let times = 100;
        let volume = 0;
        let upBy = currentVolume / times;
        //setVolume(volume);
        player.volume(volume);
        let interval = setInterval(function () {
          if (times > 0) {
            volume = volume + upBy;
            //console.log(volume);
            //setVolume(volume);
            player.volume(volume);
            times = times - 1;
          } else {
            clearInterval(interval);
            musicPlayerStore.getState().setIsFading(false);
          }
        }, 10);
      }
    }
  }; */

  const getMoreMusicTracks = () => {
    if (playQueue && singers) {
      console.log("createPlayListCompactItemList", singers[0]);
      setPaddingBottom("muvika-music-list", -50);
      if (playQueue.items.length == 0) {
        emptyPlayer();
      }
      if (repeatPlayList) {
        if ((!currentPerformance || playQueue.items.length < 4)) {
          addPlayListToTheEnd(sessionToken, repeatPlayList);
        }
      } else {
        if ((!currentPerformance || playQueue.items.length < 4) && playerFilter) {
          if (!isGettingMusic) {
            console.log("playerFilter", playerFilter);
            getMoreTracks(sessionToken, 5, singers[0], playerFilter);
          }
        }
      }
    } else {
      emptyPlayer();
    }
  };

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (streamUrl !== "") {
        musicPlayerStore.getState().setIsTrackLogSent(false);
        console.log("playing", streamUrl);
        player.src(streamUrl);
        player.currentTime(playerStore.getState().currentTime);
        console.log(isPlaying.isPlaying, isPaused.isPaused, isPlayerStopped.isStopped);
        if ((isPlaying.isPlaying || !isPaused.isPaused) && isPlayerStopped.isStopped) {
          fadeIn();
        } else {
          setIsWaitingForNextPrev(false);
          player.pause();
          if (!musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
            musicPlayerStore.getState().setIsMusicReallyPaused(true);
          }
        }
        player.off('ended');
        player.one('ended', function () {
          addPerformanceToHistory(sessionToken, currentPerformance);
          deletePerformance(sessionToken, currentPerformance.unique_id);
          getMoreMusicTracks();
        });
        player.off('timeupdate');
        player.on('timeupdate', throttle(function () {
          if (!playerStore.getState().isStopped.isStopped && !player.paused()) {
            if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform()) {
              console.log("fadeOut", "timeupdate")
              fadeOut();
            } else {
              player.pause();
              if (!musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
                musicPlayerStore.getState().setIsMusicReallyPaused(true);
              }
            }
          }
          setCurrentTime(player.currentTime());
          if (!musicPlayerStore.getState().isTrackLogSent.isTrackLogSent && player.currentTime() >= 30 && currentTrack) {
            musicPlayerStore.getState().setIsTrackLogSent(true);
            MuvikaService.setTrackLog(sessionToken, currentTrack, 0, 0);
          }
        }, 500));
      } else {
        player.reset();
        musicPlayerStore.getState().softReset();
      }
    }
  }, [streamUrl]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (isMusicOn) {
        if (isPlayerStopped.isStopped && !isPaused.isPaused) {
          //musicPlayerStore.getState().setIsTrackLogSent(false);
          setIsPlaying(true);
        } else {
          setIsPlaying(false);
        }
      }
    }
  }, [isPlayerStopped]);

  useEffect(() => {
    const player = playerRef.current;
    console.log("isPlaying: " + isPlaying.isPlaying + " " + isPlaying.triggerFade);
    if (player) {
      const timeLeft = player.duration() - player.currentTime();
      if (isPlaying.triggerFade) {
        if (isPlaying.isPlaying) {
          if (player.paused()) {
            if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform() && timeLeft >= 2) {
              fadeIn();
            } else {
              musicPlayerStore.getState().setIsMusicReallyPaused(false);
              player.play();
            }
          }
        } else {
          if (!player.paused()) {
            if ((!isIPhone() && !isPossiblyIPad()) || Capacitor.isNativePlatform() && timeLeft >= 2) {
              console.log("fadeOut", "isPlaying")
              fadeOut();
            } else {
              player.pause();
              if (!musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
                musicPlayerStore.getState().setIsMusicReallyPaused(true);
              }
            }
          }
        }
      }
    }
  }, [isPlaying]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      player.currentTime(from.from);
    }
  }, [from]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      if (!currentVolume.doNotPropagate) {
        setPlayerVolume(currentVolume.currentVolume);
      }
    }
  }, [currentVolume]);

  useEffect(() => {
    const player = playerRef.current;
    if (player) {
      setPlayerVolume(fadeVolume);
    }
  }, [fadeVolume]);


  return (
    <div style={{ display: "none" }} data-vjs-player>
      <div ref={musicRef} />
    </div>
  );
};

export default BackgroundMusicPlayer;